export enum DamageTypeEnum{
    PARTIALLY_DAMAGED='PARTIALLY DAMAGED',
    FULLY_DAMAGED='FULLY DAMAGED'
}